import { Dispatch, SetStateAction } from 'react';
import { Nav } from 'react-bootstrap';

import classNames from 'classnames';
import { colors } from 'pages/apps/e-commerce/admin/model';

// const colorVariants: Variant[] = [
//   {
//     id: 'blue',
//     variant: 'Blue',
//     thumb: blueFront,
//     images: [blueFront, blueBack, blueSide]
//   },
//   {
//     id: 'red',
//     variant: 'Red',
//     thumb: redFront,
//     images: [redFront, redBack, redSide]
//   },
//   {
//     id: 'green',
//     variant: 'Green',
//     thumb: greenFront,
//     images: [greenFront, greenBack, greenSide]
//   },
//   {
//     id: 'purple',
//     variant: 'Purple',
//     thumb: purpleFront,
//     images: [purpleFront, purpleBack, purpleSide]
//   },
//   {
//     id: 'silver',
//     variant: 'Silver',
//     thumb: silverFront,
//     images: [silverFront, silverBack, silverSide]
//   },
//   {
//     id: 'yellow',
//     variant: 'Yellow',
//     thumb: yellowFront,
//     images: [yellowFront, yellowBack, yellowSide]
//   },
//   {
//     id: 'orange',
//     variant: 'Orange',
//     thumb: orangeFront,
//     images: [orangeFront, orangeBack, orangeSide]
//   }
// ];

const ProductColorNav = ({
  selectedVariantKey,
  setSelectedVariantKey,
  colorVariants
}: {
  selectedVariantKey: string;
  setSelectedVariantKey: Dispatch<SetStateAction<string>>;
  colorVariants: string[];
}) => {
  return (
    <Nav
      className="gap-2"
      activeKey={selectedVariantKey}
      onSelect={selectedKey => setSelectedVariantKey(selectedKey as string)}
    >
      {colorVariants.map(color => (
        <ProductColorNavItem
          key={color}
          item={color}
          isActive={color === selectedVariantKey}
        />
      ))}
    </Nav>
  );
};

const ProductColorNavItem = ({
  item,
  isActive
}: {
  item: string;
  isActive: boolean;
}) => {
  return (
    <Nav.Item className="">
      <Nav.Link
        eventKey={item}
        className={classNames('border border-2 rounded-1 p-0', {
          'border-primary': isActive
        })}
      >
        <div
          style={{
            width: '25px',
            height: '25px',
            backgroundColor: colors[item as keyof typeof colors],
            opacity: 0.7
          }}
        />
      </Nav.Link>
    </Nav.Item>
  );
};

export default ProductColorNav;
